


































































































































import axios from 'axios';

import { debounce } from 'lodash';
import CoCardMarketItem from '../../components/Molecules/co-card-market-item/CoCardMarketItem.vue';
import { MarketItem } from '../../components/Molecules/co-card-market-item/models.ts';
import { Event } from '../../components/Molecules/co-card-event/models.ts';
import CoCardEvent from '../../components/Molecules/co-card-event/CoCardEvent.vue';
import CoPost from '../../components/Organisms/co-post/CoPost.vue';
import { User } from '../../components/Molecules/co-card-page/models.ts';
import CoCardPage from '../../components/Molecules/co-card-page/CoCardPage.vue';
import CoCardMember from '../../components/Molecules/co-card-member/CoCardMember.vue';

export default {
    name: 'Search',
    i18n: {
        messages: {
            en: {
                searching: "Searching for '{query}' ...",
                results: '1 result | {n} results',
                noresultsforkeyword: "We couldn't find anything for '{query}'.",
                searchhelp: 'Try different or less specific keywords.',
            },
            de: {
                searching: "Suche nach '{query}' ...",
                results: '1 Ergebnis | {n} Ergebnisse',
                noresultsforkeyword: "Wir konnten nichts zu '{query}' finden.",
                searchhelp: 'Versuches mit einer anderen oder weniger spezifischen Suche.',
            },
        },
    },
    components: {
        CoCardEvent,
        CoCardMarketItem,
        CoCardPage,
        CoCardMember,
        CoPost,
    },
    data() {
        return {
            searchResults: false,
            searchLoading: true,
            search: this.$route.query.term,
            keycode: '',
            feed: [],
            feedBank: [],
            feedAdd: [],
            results: 0,

            isMarketOn: this.$store.state.space.MarkeplaceOn,

            authors: {},
            postAuthors: {},
            userProfiles: {},
            userDirectory: {},
            channelList: null,
            me: this.$store.state.me,
            circlesOn: this.$store.state.circlesOn,
            debouncedChangeSearchTerm: null,
            contentTypesFilter: [],
        };
    },
    computed: {
        query() {
            return this.$route.query.term;
        },
        isInMobileApp() {
            return this.$store?.state?.isInMobile;
        },
        filteredFeed() {
            if (!this.contentTypesFilter || this.contentTypesFilter.length === 0) {
                return this.feed;
            }
            return this.feed.filter((item) => this.contentTypesFilter.includes(item.type));
        },
        filteredResultsCount() {
            return this.filteredFeed.length;
        },
        currentSpaceID() {
            return this.$store.state.space.ID;
        },
        isMatchingEnabledForSpace() {
            if (!this.$store || !this.$store.state || !this.$store.state.space) {
                return false;
            }

            return !this.$store.state.space.MatchingOff;
        },
        // Keep page results out of search when the member-facing pages feature is disabled.
        isPagesEnabled() {
            return !this.$store?.state?.space?.PagesOff;
        },
    },
    watch: {
        '$route.query.term': async function () {
            if (this.circlesOn) {
                await this.makeExperimentalSearch();
                this.searchLoading = false;
            } else {
                await this.makeSearch();
                this.searchLoading = false;
            }
        },
    },
    beforeDestroy() {
        this.feed = [];
        if (this.debouncedChangeSearchTerm) {
            this.debouncedChangeSearchTerm.cancel();
        }
        this.changeSearchTerm('');
    },
    destroyed() {
        window.removeEventListener('scroll', this.scroll);
    },
    created() {
        this.debouncedChangeSearchTerm = debounce((value) => {
            this.changeSearchTerm(value);
        }, 300);
    },
    mounted() {
        this.scroll();
        this.runAsyncLoadingFunctions();
    },
    methods: {
        removeFilterItem(item) {
            this.contentTypesFilter = this.contentTypesFilter.filter((i) => i !== item);
        },
        changeSearchTerm(value) {
            const normalizedValue = value || '';
            // update query param
            this.$router.push({ query: { term: normalizedValue } });
        },
        onInputSearch(value) {
            const normalizedValue = value || '';
            this.search = normalizedValue;
            if (this.debouncedChangeSearchTerm) {
                this.debouncedChangeSearchTerm(normalizedValue);
            }
        },
        async runAsyncLoadingFunctions() {
            this.searchLoading = true;
            if (this.circlesOn) {
                await Promise.all([this.makeExperimentalSearch(), this.getChannelList()]);
            } else {
                await Promise.all([this.makeSearch(), this.getChannelList()]);
            }
            this.searchLoading = false;
        },
        viewItem(id, type) {
            if (type === 'project') {
                this.$router.push(`/project/${id}`);
            } else if (type === 'user') {
                this.$router.push(`/profile/${id}`);
            }
        },

        async makeSearch() {
            this.searchLoading = true;
            this.feed = [];
            this.feedBank = [];
            this.feedAdd = [];
            const query = this.$route.query.term;
            if (!query || query.length === 0) {
                this.searchLoading = false;
                return;
            }
            await axios({
                method: 'GET',
                url: `/search/v2/${query}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(async (response) => {
                    if (response && response.data) {
                        if (response.data.objects) {
                            // filter out the jobs if the market is off
                            let { objects } = response.data;
                            if (!this.isMarketOn) {
                                objects = objects.filter((item) => item.type !== 'job');
                            }
                            if (!this.isPagesEnabled) {
                                objects = objects.filter((item) => item.type !== 'project');
                            }

                            // add key to each object
                            objects = objects.map((item) => ({
                                ...item,
                                key: Math.random(),
                            }));

                            this.$set(this.$data, 'feedBank', objects);
                            this.results = this.feedBank.length;
                            if (this.feedBank.length > 20) {
                                this.feedAdd.push(...this.feedBank.slice(0, 20));
                                this.feedBank = this.feedBank.slice(20);
                            } else {
                                this.feedAdd.push(...this.feedBank);
                                this.feedBank = [];
                            }
                        } else {
                            this.$set(this.$data, 'feedBank', []);
                            this.$set(this.$data, 'feedAdd', []);
                        }
                        await this.prefetchUsersForFeedItems(this.feedAdd);
                        await this.mapFeedAddItems();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        async makeExperimentalSearch() {
            this.searchLoading = true;
            this.feed = [];
            this.feedBank = [];
            this.feedAdd = [];
            const query = this.$route.query.term;
            if (!query || query.length === 0) {
                this.searchLoading = false;
                return;
            }
            await axios({
                method: 'GET',
                url: `/search/tmp/${query}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(async (response) => {
                    if (response && response.data) {
                        if (response.data.objects) {
                            // filter out the jobs if the market is off
                            let { objects } = response.data;
                            if (!this.isMarketOn) {
                                objects = objects.filter((item) => item.type !== 'job');
                            }
                            if (!this.isPagesEnabled) {
                                objects = objects.filter((item) => item.type !== 'project');
                            }

                            // add key to each object
                            objects = objects.map((item) => ({
                                ...item,
                                key: Math.random(),
                            }));

                            this.$set(this.$data, 'feedBank', objects);
                            this.results = this.feedBank.length;
                            if (this.feedBank.length > 20) {
                                this.feedAdd.push(...this.feedBank.slice(0, 20));
                                this.feedBank = this.feedBank.slice(20);
                            } else {
                                this.feedAdd.push(...this.feedBank);
                                this.feedBank = [];
                            }
                        } else {
                            this.$set(this.$data, 'feedBank', []);
                            this.$set(this.$data, 'feedAdd', []);
                        }
                        await this.prefetchUsersForFeedItems(this.feedAdd);
                        await this.mapFeedAddItems();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        buildCardAuthor(user): User {
            const displayName =
                user.Profile && user.Profile.FirstName
                    ? `${user.Profile.FirstName} ${user.Profile.LastName}`
                    : user.Profile?.Name;
            return {
                ID: user.ID,
                Name: displayName,
                ImageURL: user.Profile?.ImageURL,
                Slug: user.Slug,
                id: user.ID,
                slug: user.Slug,
                name: displayName,
                image: user.Profile?.ImageURL,
            };
        },
        buildPostAuthor(user) {
            return {
                ID: user.ID,
                Name: user.Profile?.Name,
                Slug: user.Slug,
                ImageURL: user.Profile?.ImageURL,
                Bio: user.Profile?.Bio,
            };
        },
        async prefetchUsersForFeedItems(items) {
            const contributorIDs = [];
            const marketAuthorIDs = [];
            const postAuthorIDs = [];

            (items || []).forEach((item) => {
                const obj = item.object || {};

                if (item.type === 'project') {
                    contributorIDs.push(...(obj.Contributor || obj.Owner || []));
                }

                if (item.type === 'job' && obj.AuthorID) {
                    marketAuthorIDs.push(obj.AuthorID);
                }

                if (item.type === 'post') {
                    const authorID = obj.AuthorID || obj.CreatedBy || obj.UserID;
                    if (authorID) {
                        postAuthorIDs.push(authorID);
                    }
                }
            });

            const uniqueUserIDs = Array.from(new Set([...contributorIDs, ...marketAuthorIDs, ...postAuthorIDs]));
            const idsToFetch = uniqueUserIDs.filter((id) => !this.userDirectory[id]);

            if (idsToFetch.length > 0) {
                const data = JSON.stringify({ IDS: idsToFetch.map((id) => ({ ID: id })) });
                const response = await this.$store.dispatch('listUsersByIDs', { ids: data });

                if (response?.Users) {
                    response.Users.forEach((user) => {
                        this.$set(this.userDirectory, user.ID, user);
                    });
                }
            }

            contributorIDs.forEach((id) => {
                const user = this.userDirectory[id];
                if (user) {
                    this.$set(this.userProfiles, id, {
                        ...user,
                        ...user.Profile,
                    });
                }
            });

            marketAuthorIDs.forEach((id) => {
                const user = this.userDirectory[id];
                if (user) {
                    this.$set(this.authors, id, [this.buildCardAuthor(user)]);
                }
            });

            postAuthorIDs.forEach((id) => {
                const user = this.userDirectory[id];
                if (user) {
                    this.$set(this.postAuthors, id, this.buildPostAuthor(user));
                }
            });
        },

        async getChannelList() {
            /* get the list of channels and save them in the channelList map with slug as keys */
            axios
                .get('/project/channel/list')
                .then((response) => {
                    if (response.data) {
                        // find channel title by slug
                        this.channelList = response.data.objects.map((channel) => channel.object);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(async () => {
                    await this.mapFeedAddItems();
                });
        },
        async mapFeedAddItems() {
            // map the items to the feed based on the type
            this.feedAdd = this.feedAdd.map((object) => {
                if (object.type === 'project') {
                    return this.mapPageStructure(object);
                }
                if (object.type === 'job') {
                    return this.mapMarketItemStructure(object);
                }
                if (object.type === 'event') {
                    return this.mapEventStructure(object);
                }
                if (object.type === 'post') {
                    return this.mapPostStructure(object);
                }
                return object;
            });

            // add the feedAdd to the feed
            this.feed.push(...this.feedAdd);
            this.feedAdd = [];
        },

        mapEventStructure(object) {
            const resObject = object;
            const event = object.object;
            const spaceItem = object.space;
            const e: Event = {
                id: event.ID,
                title: event.Title,
                description: event.Description,
                start: event.StartDate,
                end: event.EndDate,
                slug: event.Slug,
                image: event.ImageURL,
            };

            if (event.Participants && event.Participants.length > 0) {
                e.attend = event.Participants.includes(this.me.ID);
            }

            if (spaceItem && spaceItem.ID !== this.$store.state.space.ID) {
                e.space = {
                    id: spaceItem.ID,
                    name: spaceItem.Name,
                    favicon: spaceItem.FaviconURL,
                    primaryColor: spaceItem.PrimaryColor,
                };
            }

            resObject.event = e;

            if (!resObject.key) {
                resObject.key = Math.random();
            } else {
                resObject.key += 1;
            }

            return resObject;
        },
        mapPostStructure(object) {
            const resObject = object;
            const post = resObject.object || {};
            const authorID = post.AuthorID || post.CreatedBy || post.UserID;

            if (authorID && this.postAuthors[authorID]) {
                post.Author = this.postAuthors[authorID];
            }

            if (resObject.space) {
                post.Space = resObject.space;
            }

            const tmpImages = post.Images || post.ImageURLs || [];
            post.Images = tmpImages.map((image) => {
                if (image && typeof image === 'object' && 'ImageURL' in image) {
                    return image;
                }
                return { ImageURL: image };
            });

            post.Type = resObject.type;
            resObject.object = post;

            if (!resObject.key) {
                resObject.key = Math.random();
            } else {
                resObject.key += 1;
            }

            return resObject;
        },
        mapMarketItemStructure(object) {
            const resObject = object;
            const marketItem = object.object;
            const spaceItem = object.space;
            const e: MarketItem = {
                id: marketItem.ID,
                title: marketItem.Title,
                description: marketItem.Description,
                slug: marketItem.Slug,
                image: marketItem.ImageURL,
                authorId: marketItem.AuthorID,
                author: this.authors[marketItem.AuthorID] ? this.authors[marketItem.AuthorID][0] : null,
                open: marketItem.Open,
            };

            if (marketItem.Participants && marketItem.Participants.length > 0) {
                e.followed = marketItem.Participants.includes(this.me.ID);
            }

            if (spaceItem && spaceItem.ID !== this.$store.state.space.ID) {
                e.space = {
                    id: spaceItem.ID,
                    name: spaceItem.Name,
                    favicon: spaceItem.FaviconURL,
                    primaryColor: spaceItem.PrimaryColor,
                };
            }

            resObject.marketItem = e;

            if (!resObject.key) {
                resObject.key = Math.random();
            } else {
                resObject.key += 1;
            }

            return resObject;
        },
        mapPageStructure(object) {
            const resObject = object;
            const page = resObject.object || {};
            const contributors = (page.Contributor || page.Owner || [])
                .map((id) => this.userProfiles[id])
                .filter(Boolean);
            const tmpImages = page.Images || page.ImageURL || page.ImageURLs || [];

            page.Contributors = contributors;
            page.Images = tmpImages.map((image) => {
                if (image && typeof image === 'object' && 'ImageURL' in image) {
                    return image;
                }
                return {
                    ImageURL: image || null,
                };
            });

            if (page.Images.length === 0) {
                page.Images = [{ ImageURL: null }];
            }

            if (resObject.space) {
                // Preserve the original space shape so CoCardPage can show cross-space metadata.
                page.Space = resObject.space;
            }

            resObject.page = page;

            if (!resObject.key) {
                resObject.key = Math.random();
            } else {
                resObject.key += 1;
            }

            return resObject;
        },
        mapSpaceObject(spaceItem) {
            if (!spaceItem) {
                return null;
            }

            if (!spaceItem.ID) {
                return null;
            }

            if (spaceItem.ID === this.currentSpaceID) {
                return null;
            }
            const obj = {
                id: spaceItem.ID,
                name: spaceItem.Name,
                favicon: spaceItem.FaviconURL,
                primaryColor: spaceItem.PrimaryColor,
            };
            return obj;
        },

        getChannelSlugByID(ID) {
            // get channel slug by ID
            const slug = '';

            if (!this.channelList) {
                return slug;
            }

            // clone the channel list map to avoid mutation
            const channelList = JSON.parse(JSON.stringify(this.channelList));

            const channel = channelList.find((c) => c.ID === ID);
            return channel ? channel.Slug : slug;
        },

        sendMessage(userObj: User) {
            if (!userObj || !userObj.id) return;
            const thread = {
                Participants: [this.me.ID, userObj.id],
            };
            axios({
                method: 'POST',
                url: '/chat/t',
                withCredentials: true,
                data: JSON.stringify(thread),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.$router.push(`/messenger/${response.data.ID}`);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        scroll() {
            window.onscroll = () => {
                const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
                const totalScroll = document.documentElement.scrollHeight - window.innerHeight;
                const scrollPercentage = (scrollTop / totalScroll) * 100;

                if (scrollPercentage > 85) {
                    if (this.feedBank.length !== 0 && this.feedBank.length > 10) {
                        this.feedAdd.push(...this.feedBank.slice(0, 10));
                        this.feedBank = this.feedBank.slice(10);
                    } else if (this.feedBank.length !== 0 && this.feedBank.length <= 10) {
                        this.feedAdd.push(...this.feedBank);
                        this.feedBank = [];
                    }
                    Promise.all([this.prefetchUsersForFeedItems(this.feedAdd)]).then(() => {
                        this.mapFeedAddItems();
                    });
                }
            };
        },
    },
};
